import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { VendorReturnDetailBus } from "./VendorReturnDetailBus";
import { CommonFunctions } from "../static/common-functions";

export class DepartmentBus extends BaseBus
 {
     constructor(busObj: BaseBus = null) {
         super(busObj);
         this.insertDt = DateFunctions.getDate(this.insertDt);
         this.updateDt = DateFunctions.getDate(this.updateDt);

     }

     CID(): any {
         return this.departmentId;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
     }
    setFromForm(data: DepartmentBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        this.updateDt = dateNow;
        this.updateUserId = data.insertUserId;
        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }

    departmentId: any;
    departmentName: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
}
